import { useStoreActions } from '@app/store';
import { isLocaleLoaded } from '@constants/locales';
import { useEffect } from 'react';

// The route loader sets the link's `?locale=` without loading its label
// bundle, so the form's own copy would stay English; load it (and re-render)
// the same way the language picker does.
export const useLocaleLabelsLoaded = (locale) => {
  const { setLocaleAction } = useStoreActions();

  useEffect(() => {
    if (locale && !isLocaleLoaded(locale)) setLocaleAction(locale);
  }, [locale, setLocaleAction]);
};
